import { render, staticRenderFns } from "./setup_list.vue?vue&type=template&id=f6202cee"
import script from "./setup_list.vue?vue&type=script&lang=js"
export * from "./setup_list.vue?vue&type=script&lang=js"
import style0 from "./setup_list.vue?vue&type=style&index=0&id=f6202cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports